const dictionary = {
  Y: 'yyyy',
  m: 'MM',
  d: 'dd',
  H: 'HH',
  h: 'hh',
  i: 'mm',
  s: 'ss'
};

export const convertPhpDateFormatToDateFns = inputFormat =>
  inputFormat
    .split('')
    .map(char => dictionary[char] || char)
    .join('');
